<div class="opt-dialog-container">
  <div class="header">
    <h1 mat-dialog-title>My Profile</h1>
    <span class="filler"></span>
    <button
      mat-flat-button
      class="mat-small-button"
      (click)="onChangePasswordClick()"
      *ngIf="!isError"
    >
      <mat-icon>vpn_key</mat-icon>
      <span>Password</span>
    </button>
    <button mat-flat-button class="mat-small-button" (click)="onLogoutClick()">
      <mat-icon>logout</mat-icon>
      <span>Log out</span>
    </button>
  </div>

  <form *ngIf="isReady" [formGroup]="profileForm">
    <div mat-dialog-content class="profile-form">
      <div class="form-line">
        <div>
          <mat-label><label for="firstName">First Name</label></mat-label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              type="text"
              formControlName="firstName"
              cdkFocusInitial
              id="firstName"
            />
          </mat-form-field>
          <ng-container *ngIf="firstName.dirty || firstName.touched">
            <mat-error *ngIf="firstName.hasError('required')">
              Please fill in the first name
            </mat-error>
            <mat-error *ngIf="firstName.hasError('maxlength')">
              Must be under 16 characters
            </mat-error>
          </ng-container>
        </div>

        <div>
          <mat-label><label for="lastName">Last Name</label></mat-label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              type="text"
              formControlName="lastName"
              id="lastName"
            />
          </mat-form-field>
          <ng-container *ngIf="lastName.dirty || lastName.touched">
            <mat-error *ngIf="lastName.hasError('required')">
              Please fill in the last name
            </mat-error>
            <mat-error *ngIf="lastName.hasError('maxlength')">
              Must be under 16 characters
            </mat-error>
          </ng-container>
        </div>
      </div>

      <div class="form-line">
        <div>
          <mat-label><label for="email">Email</label></mat-label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput type="text" id="email" formControlName="email" />
          </mat-form-field>
          <ng-container *ngIf="email.dirty || email.touched">
            <mat-error
              *ngIf="email.hasError('email') && !email.hasError('required')"
            >
              Please enter a correct email
            </mat-error>
            <mat-error *ngIf="email.hasError('required')">
              Please fill in the email
            </mat-error>
          </ng-container>

          <span class="not-confirmed" *ngIf="!isEmailConfirmed">
            Your email is not confirmed:
            <button
              mat-flat-button
              class="mat-small-button"
              (click)="onConfirmEmailClick()"
            >
              Confirm
            </button>
          </span>
        </div>
      </div>

      <div class="form-line" *ngIf="!isInsightsOnlyUser">
        <div>
          <h2>Email Preferences</h2>

          <div class="mat-select-header">
            <mat-checkbox
              color="primary"
              class="mat-checkbox"
              formControlName="cbIndividualSale"
            >
              Receive individual sale email
            </mat-checkbox>
          </div>
          <div class="mat-select-header">
            <mat-checkbox
              color="primary"
              class="mat-checkbox"
              formControlName="cbInventoryAdded"
            >
              Receive new inventory email
            </mat-checkbox>
          </div>
          <div class="mat-select-header">
            <mat-checkbox
              color="primary"
              class="mat-checkbox"
              formControlName="cbPaymentComplete"
            >
              Receive payment complete email
            </mat-checkbox>
          </div>
          <div class="mat-select-header">
            <mat-checkbox
              color="primary"
              class="mat-checkbox"
              formControlName="cbDailySummary"
            >
              Receive daily summary email
            </mat-checkbox>
          </div>
          <!--
            <div class="mat-select-header">
                <mat-checkbox color="primary" class="mat-checkbox" formControlName="cbWeeklySummary">
                    Receive weekly summary email
                </mat-checkbox>
            </div>
            -->
        </div>

        <div>
          <h2>Inventory Settings</h2>

          <mat-label>
            <label for="lowPriceThreshold">Low Price Threshold</label>
            <mat-icon
              class="label-icon"
              color="primary"
              matTooltip="Receive a warning before changing a listing price if the new price is this much lower than the current price or face value. The warning can be overridden."
            >
              info</mat-icon
            >
          </mat-label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
              formControlName="lowPriceThreshold"
              id="lowPriceThreshold"
              placeholder="Alert if price drops past %"
            >
              <mat-option
                class="mat-option-compact"
                *ngFor="let threshold of thresholdOptions"
                [value]="threshold.id"
                >{{ threshold.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <ng-container
            *ngIf="lowPriceThreshold.dirty || lowPriceThreshold.touched"
          >
            <mat-error
              *ngIf="
                lowPriceThreshold.hasError('max') ||
                lowPriceThreshold.hasError('min')
              "
            >
              Threshold should be between 1 and 100
            </mat-error>
          </ng-container>
        </div>
      </div>

      <div class="form-line">
        <div>
          <mat-label [class.notice-label]="!password.touched">
            <label for="password">Enter password to save changes</label>
          </mat-label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              [type]="isPasswordHidden ? 'password' : 'text'"
              formControlName="password"
              id="password"
              autocomplete="current-password"
            />
            <button
              mat-icon-button
              matIconSuffix
              type="button"
              [class]="isPasswordHidden ? 'color-gray-24' : 'color-sidebar-bg'"
              (click)="isPasswordHidden = !isPasswordHidden"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="isPasswordHidden"
            >
              <mat-icon>{{
                isPasswordHidden ? 'visibility_off' : 'visibility'
              }}</mat-icon>
            </button>
          </mat-form-field>

          <mat-error
            *ngIf="
              password.hasError('required') &&
              (password.dirty || password.touched)
            "
          >
            Please fill in the current password
          </mat-error>
          <div *ngIf="badResult">
            <mat-error *ngFor="let error of badResult.errors">
              {{ error }}
            </mat-error>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-flat-button type="button" (click)="cancel()">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        (click)="update()"
        [disabled]="profileForm.disabled"
      >
        <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
        <span *ngIf="!isLoading">Save</span>
      </button>
    </div>
  </form>

  <div *ngIf="!isReady && !isError" class="empty">
    <mat-spinner></mat-spinner>
  </div>

  <ng-container *ngIf="isError">
    <div class="empty">
      <mat-icon>group</mat-icon>
      <mat-error>
        There was a problem loading your profile.<br />
        If the problem persists, please log out and log back in.
      </mat-error>
    </div>
    <div mat-dialog-actions>
      <button mat-flat-button type="button" (click)="cancel()">Cancel</button>
    </div>
  </ng-container>
</div>
